import {InlineLink, Text} from '@primer/react-brand'

import type {GeneralConsentLanguageProps} from './types'
import {getAnalyticsEvent} from '../../../../../../lib/utils/analytics'

import {t} from '../../../../../../lib/utils/localization'

export default function UnitedStates({children, privacyStatementHref}: GeneralConsentLanguageProps) {
  return (
    <>
      {children}
      <Text>
        {t('I will receive personalized communications and targeted advertising from GitHub and affiliates. See the')}{' '}
        <InlineLink
          {...getAnalyticsEvent({
            action: t('GitHub Privacy Statement'),
            tag: 'hyperlink',
            context: 'consent_language_united_states',
            location: 'form',
          })}
          href={privacyStatementHref}
        >
          {t('GitHub Privacy Statement')}
        </InlineLink>{' '}
        {t('for more details.')}
      </Text>
    </>
  )
}
